module.exports = __webpack_public_path__ + "static/media/JinRong4.d967e768.png";